import { render, staticRenderFns } from "./StaticQuoteTable.vue?vue&type=template&id=23bd2d65&"
import script from "./StaticQuoteTable.vue?vue&type=script&lang=js&"
export * from "./StaticQuoteTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StaticQuoteTable.vue"
export default component.exports